
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { environment } from "../../environments/environment";
import { getPerformanceApiBase } from "../service/modulo-desempeno/mock/mock-config";

let echoInstance: Echo<any> | null = null;
window.Pusher = Pusher;

// console.log("log laravel-echo.ts!!")

// export const echo = new Echo({
//   authEndpoint: environment.MIX_PUSHER_BACKEND_API + '/broadcasting/auth',
//   broadcaster: 'pusher',
//   key: environment.MIX_PUSHER_APP_KEY,
//   wsHost: environment.MIX_PUSHER_HOST,
//   wsPort: environment.MIX_PUSHER_PORT,
//   wssPort: environment.MIX_PUSHER_PORT,
//   forceTLS: environment.MIX_PUSHER_TLS,
//   encrypted: true,
//   disableStats: true,
//   enabledTransports: ['ws', 'wss'],
//   cluster: environment.MIX_PUSHER_APP_CLUSTER,
// });

// Los canales de presencia de Desempeño (`presence-performance.*`) los autoriza el backend de
// Desempeño, con su propio token; el resto, el backend de aprendizaje con el token de sesión.
// El socket es uno solo: los dos backends comparten la app de Pusher/soketi, así que la firma
// de cualquiera de los dos vale para la misma conexión.
const PERFORMANCE_CHANNEL_PREFIX = 'presence-performance.';

const resolveChannelAuth = (channelName: string, pusherApiUrl: string, token: string) => {
  if (channelName.startsWith(PERFORMANCE_CHANNEL_PREFIX)) {
    return {
      endpoint: getPerformanceApiBase() + 'broadcasting/auth',
      // Se lee en cada autorización: el token de Desempeño se obtiene recién al entrar al
      // módulo, después de creada esta instancia.
      token: localStorage.getItem('performance_token'),
    };
  }

  return { endpoint: pusherApiUrl + 'broadcasting/auth', token };
};

export const initializeEcho = (token: string, MIX_PUSHER_APP_KEY, MIX_PUSHER_HOST, pusherApiUrl) => {
  if (!echoInstance) {
    echoInstance = new Echo({
      broadcaster: 'pusher',
      key: MIX_PUSHER_APP_KEY,
      wsHost: MIX_PUSHER_HOST,
      wsPort: environment.MIX_PUSHER_PORT,
      wssPort: environment.MIX_PUSHER_PORT,
      forceTLS: environment.MIX_PUSHER_TLS,
      encrypted: true,
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
      cluster: environment.MIX_PUSHER_APP_CLUSTER,
      // Con `channelAuthorization`, pusher-js ignora `authEndpoint`/`auth`: toda autorización
      // de canal pasa por este handler, que elige backend y token según el canal.
      channelAuthorization: {
        customHandler: ({ socketId, channelName }, callback) => {
          const auth = resolveChannelAuth(channelName, pusherApiUrl, token);

          if (!auth.token) {
            callback(new Error('Sin token para autorizar ' + channelName), null);
            return;
          }

          fetch(auth.endpoint, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${auth.token}`,
            },
            body: JSON.stringify({ socket_id: socketId, channel_name: channelName }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`No se pudo autorizar ${channelName} (${response.status})`);
              }
              return response.json();
            })
            .then((data) => callback(null, data))
            .catch((error) => callback(error, null));
        },
      },
    });
  }
  return echoInstance;
};

export const getEcho = () => {
  if (!echoInstance) {
    console.log('Echo no ha sido inicializado.')
  }
  return echoInstance;
};

// Desconecta y descarta la instancia. Llamarlo SIEMPRE en lugar de `getEcho().disconnect()`:
// sin soltar la referencia, initializeEcho() devolvería para siempre la instancia ya
// desconectada —y con el token anterior en auth.headers—, así que al volver a iniciar
// sesión sin recargar la app ningún canal conectaría y /broadcasting/auth respondería 403.
export const destroyEcho = () => {
  if (!echoInstance) {
    return;
  }

  try {
    echoInstance.disconnect();
  } catch (error) {
    console.error('Error al desconectar Echo.', error);
  }

  echoInstance = null;
};





















// const echo = new Echo({
//     authEndpoint: environment.VITE_BACKEND_API + '/broadcasting/auth',
//     broadcaster: 'pusher',
//     key: environment.MIX_PUSHER_APP_KEY,
//     wsHost: environment.MIX_PUSHER_HOST,
//     wsPort: environment.MIX_PUSHER_PORT,
//     wssPort: environment.MIX_PUSHER_PORT,
//     forceTLS: environment.MIX_PUSHER_TLS,
//     encrypted: true,
//     disableStats: true,
//     enabledTransports: ['ws', 'wss'],
//     cluster: environment.MIX_PUSHER_APP_CLUSTER,

//     auth: {
//         headers: {
//             Authorization: 'Bearer ' + token,
//             // 'Content-Type': 'application/json',
//         }
//     }
// });

// export { echo }
